// noinspection JSUnusedGlobalSymbols

import Helper from '../../../client/helper.js'
import Toast from '../../../client/toast.js'

export default class Contact
{
	static confirm(form, confirm, message, modal)
	{
		const data = new FormData(form)
		data.set('__action', 'confirm')

		$.ajax({
			url : '/contact/confirm',
			type: 'POST',

			processData: false,
			contentType: false,

			data   : data,
			success: (data) =>
			{
				if(!data.success) Toast.warning(data.message)
				else
				{
					$(form).find('input[type="text"], input[type="email"], select').each((index, element) =>
					{
						$(confirm).find('input[name="' + element.name + '"]').val(element.value)
					})

					const checked = []

					$(form).find('input[name="method[]"]:checked').each(function(index, element)
					{
						checked.push(element.value)
					})

					for(let index = 0; index < checked.length; index++)
					{
						if(checked[index] === 'その他') checked[index] += ' (' + $(form).find('input[name="method_other"]').val() + ')'
					}

					$(confirm).find('input[name="method[]"]').val(checked.join(', '))
					const content = $(form).find('textarea').val()

					$(message).html(Helper.escape_html(content).replace(/\n/g, '<br>'))
					modal.remodal().open()
				}
			},
		})
	}

	static submit(modal, form)
	{
		modal.remodal().close()

		form.__action = 'submit'
		App.common.Network.form_post(form, (success) => { if(success) location.href = '/contact_sent/' })
	}

	static other_method(checkbox)
	{
		const input = checkbox.form.method_other
		input.disabled = !checkbox.checked

		if(checkbox.checked) $(input).removeClass('_disabled')
		else $(input).addClass('_disabled')
	}

	static postal(form, postal, prefecture, address)
	{
		$.get('/_postal/', {code: form[postal].value}, function(data)
		{
			if(data.error) Toast.warning(data.error)
			else
			{
				form[prefecture].value = data.prefecture
				form[address].value = data.address
			}
		})
	}
}
